import React from 'react'
import { Typography } from '@material-ui/core'

const NotFound = () =>
  <>
    <Typography variant="h3" align="center">404 page not found</Typography>
    <Typography variant="body1" align="center">We are sorry but the page you are looking for does not exist.</Typography>
  </>

export default NotFound